import { Calendar } from 'components/Calendar';
import React from 'react';

import './CalendarMobile.scss';
import { Button } from 'components/Button/Button';
import { logout } from 'features/auth';
import { useDispatch } from 'react-redux';

export const CalendarMobilePage: React.FC = () => {
    const dispatch = useDispatch();
    return (
        <main id="calendar-mobile">
            <div className="calendar-mobile-header">
                <h2>Agenda</h2>
                <Button
                    label="Déconnexion"
                    variant="light"
                    className="small"
                    type="button"
                    onClick={() => {
                        dispatch(logout())
                    }}
                />
            </div>
            <Calendar view="day" title="Calendrier" />
        </main>
    );
};
